// eslint-disable-next-line import/prefer-default-export
export const loading = state => state.processes > 0;
